<template>
    <div class="index-info" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
        <div class="header-bg">
            <div class="content-nav-bar">
                <van-nav-bar>
                    <template
                        #left
                        v-if="
                            $route.query.dtzhCheckedYzList ||
                            $route.query.dtzhHcCheckedYzList ||
                            $route.query.mark
                        "
                    >
                        <van-icon name="cross" size="18" @click="close" />
                    </template>
                    <template #left v-else>
                        <van-icon name="arrow-left" size="18" @click="goBack" />
                    </template>

                    <template #title>
                        <span
                            class="pageTitle"
                            v-if="
                                $store.state.Obj.isEdit ||
                                !compareVersions($route.query.version, 9.69) ||
                                $route.query.dtzhCheckedYzList ||
                                $route.query.dtzhHcCheckedYzList ||
                                $route.query.createType == 'sslh'
                            "
                        >
                            {{ defaultIndex == 0 ? 'A股因子' : 'ETF因子' }}
                        </span>

                        <span class="pageTitle" @click="handleClickSelYzType" v-else>
                            {{ defaultIndex == 0 ? 'A股因子' : 'ETF因子' }}
                            <van-icon name="play" />
                        </span>
                    </template>

                    <template #right>
                        <van-icon name="search" size="18" @click="goSelectYz" />
                    </template>
                </van-nav-bar>
            </div>

            <div class="content">
                <div class="second-level">
                    <van-tabs @click="handleClickNav">
                        <van-tab
                            :title="item.ClassName"
                            v-for="item in navList"
                            :key="item.ClassId"
                            :disabled="tabDisabled"
                        >
                        </van-tab>
                    </van-tabs>
                </div>

                <div class="content_bottom">
                    <div class="nav" :style="`height:calc(100vh - ${contentNavBar + 41}px)`">
                        <van-sidebar v-model="activeKey">
                            <van-sidebar-item
                                @click="handleClickTabs"
                                v-for="item in childrenList"
                                :key="item.SubClassId + item.SubClassName"
                                :title="item.SubClassName"
                                :disabled="tabDisabled"
                            />
                        </van-sidebar>
                    </div>

                    <div class="bottom_right">
                        <div class="title">
                            <span
                                class="left"
                                :class="
                                    SubClassName == '热门因子' ||
                                    SubClassName == '热门使用' ||
                                    SubClassName == '最近浏览' ||
                                    SubClassName == '常用'
                                        ? 'specialBg'
                                        : ''
                                "
                            >
                                {{ SubClassName }}
                            </span>
                            <div
                                class="right"
                                v-if="
                                    ClassId != 9999 &&
                                    ClassId != 9998 &&
                                    ClassId != 10001 &&
                                    SubClassName != '常用'
                                "
                            >
                                <p class="sort_d" @click="handleClickZf">
                                    今日涨幅
                                    <i
                                        class="angle_top"
                                        :class="zfSort == 1 ? 'angle_top_checked' : ''"
                                    ></i>
                                    <i
                                        class="angle_bottom"
                                        :class="zfSort == 2 ? 'angle_bottom_checked' : ''"
                                    ></i>
                                </p>
                                <p class="sort_d" style="margin-left: 15px" @click="handleClickXhs">
                                    今日信号数
                                    <i
                                        class="angle_top"
                                        :class="xhsSort == 1 ? 'angle_top_checked' : ''"
                                    ></i>
                                    <i
                                        class="angle_bottom"
                                        :class="xhsSort == 2 ? 'angle_bottom_checked' : ''"
                                    ></i>
                                </p>
                            </div>
                        </div>

                        <van-list
                            v-model="loading"
                            :finished="finished"
                            :finished-text="inishedText"
                            @load="listFun"
                            class="nav-details"
                            :immediate-check="false"
                            :offset="30"
                            :style="`height:calc(100vh - 4.3rem);`"
                        >
                            <van-empty
                                v-show="!mergedArray.length && !loading"
                                :image="require('@/assets/image/notData.png')"
                            />

                            <van-row gutter="8">
                                <van-col
                                    span="12"
                                    v-for="(item, index) in mergedArray"
                                    :key="index"
                                >
                                    <div
                                        v-if="item.yzType == 0"
                                        class="common"
                                        :style="
                                            checkIDExists(checkedYzList, item.ID)
                                                ? 'border:1px solid #286DF7;'
                                                : ''
                                        "
                                        @click.stop="handleClickCard(item)"
                                        ref="pElements"
                                    >
                                        <span
                                            v-if="!checkIDExists(checkedYzList, item.ID)"
                                            @click.stop="addYz(item)"
                                            class="handleClickYz"
                                        >
                                            <img src="@/assets/image/tj.png" alt="" />
                                        </span>
                                        <span
                                            v-else
                                            @click.stop="delYz(item)"
                                            class="handleClickYz"
                                        >
                                            <img src="@/assets/image/sc.png" alt="" />
                                        </span>

                                        <h2>
                                            <p class="FactorName van-multi-ellipsis--l2">
                                                <span
                                                    class="pElementsSpan"
                                                    :ref="'pElementsSpan_' + index"
                                                    :style="
                                                        compareVersions($route.query.version, 9.71)
                                                            ? item.spanWidth < 70
                                                                ? 'font-size: 0.37rem'
                                                                : 'font-size: 0.29rem'
                                                            : item.spanWidth < 90
                                                            ? 'font-size: 0.37rem'
                                                            : 'font-size: 0.29rem'
                                                    "
                                                >
                                                    {{ item.FactorName }}
                                                </span>
                                                <img
                                                    src="../../assets/image/blockImg/vipIcon.png"
                                                    alt=""
                                                    class="vipIcon"
                                                    v-if="
                                                        item.ExtendType &&
                                                        compareVersions($route.query.version, 9.71)
                                                    "
                                                />
                                            </p>
                                        </h2>
                                        <div class="n-content">
                                            <p :class="[judgeColor(item.RiZhangFu)]">
                                                {{ toFixedNum(item.RiZhangFu * 100, 2, '%') }}
                                            </p>
                                            <p class="zhi">{{ item.XinHaoShuLiang || 0 }}只</p>
                                        </div>
                                    </div>

                                    <div
                                        v-else
                                        class="common special"
                                        :style="
                                            checkIDExists(checkedYzList, item.ID)
                                                ? 'border:1px solid #286DF7;'
                                                : ''
                                        "
                                        @click.stop="handleClickCard(item)"
                                    >
                                        <div class="special_con">
                                            <div
                                                class="FactorName"
                                                style="display: flex; align-items: center"
                                            >
                                                <p class="van-ellipsis specialFactorName">
                                                    <span
                                                        class="pElementsSpan2"
                                                        :ref="'pElementsSpan2_' + index"
                                                        :style="
                                                            item.yzType === 4
                                                                ? item.spanWidth < 70
                                                                    ? 'font-size: 0.37rem'
                                                                    : 'font-size: 0.29rem'
                                                                : item.spanWidth < 90
                                                                ? 'font-size: 0.37rem'
                                                                : 'font-size: 0.29rem'
                                                        "
                                                        >{{ item.FactorName }}</span
                                                    >
                                                </p>
                                                <span class="gs" v-if="item.yzType === 4"
                                                    >公式</span
                                                >
                                                <span class="gs" v-if="item.yzType === 6"
                                                    >自然</span
                                                >
                                                <span class="gs" v-if="item.yzType === 2"
                                                    >拖拽</span
                                                >
                                            </div>

                                            <span
                                                v-if="!checkIDExists(checkedYzList, item.ID)"
                                                @click.stop="addYz(item)"
                                                class="handleClickYz"
                                            >
                                                <img src="@/assets/image/tj.png" alt="" />
                                            </span>
                                            <span
                                                v-else
                                                @click.stop="delYz(item)"
                                                class="handleClickYz"
                                            >
                                                <img src="@/assets/image/sc.png" alt="" />
                                            </span>
                                        </div>
                                    </div>
                                </van-col>
                            </van-row>
                        </van-list>
                    </div>
                </div>
            </div>
        </div>

        <div class="bottom-pd">
            <div class="bottom-btn">
                <div class="left" @click="handleClickShowActionSheet">
                    选中的因子 <span class="num">{{ checkedYzNum }}</span>
                </div>

                <button
                    v-if="$route.query.source === 'dtzh' || $route.query.dtzhCheckedYzList"
                    class="r-btn"
                    :disabled="!checkedYzNum"
                    @click="goDtzhPreview"
                    :style="checkedYzNum ? 'color:#fff;background: #286DF7;' : ''"
                >
                    查看结果<span v-if="!isResultLoading"
                        >({{ resultNum }}{{ defaultIndex == 1 ? '只ETF' : '只股票' }})
                    </span>
                    <span v-else>
                        <van-loading
                            type="spinner"
                            :color="checkedYzNum > 0 ? '#fff' : '#858586'"
                            size="16"
                            ><span :color="checkedYzNum > 0 ? '#fff' : '#858586'"
                                >加载中</span
                            ></van-loading
                        >
                    </span>
                </button>

                <button
                    v-else
                    class="r-btn"
                    :disabled="!checkedYzNum"
                    @click="goArguments"
                    :style="checkedYzNum > 0 ? 'color:#fff;background: #286DF7;' : ''"
                >
                    选择条件
                </button>
            </div>
        </div>

        <!-- 新版交并集 -->
        <van-popup
            v-model="showActionSheet"
            position="bottom"
            @closed="checkSonFactorList"
            :style="{ height: '80%' }"
        >
            <FactorSetOperatorModal @close="showActionSheet = false"> </FactorSetOperatorModal>
        </van-popup>

        <!-- <van-action-sheet v-model="showActionSheet" title="">




      <div class="actionSheet-content" >
        22222
      </div>


      <ul class="actionSheet-content" v-if="checkedYzList.length">
        <li v-for="item in checkedYzList" :key="item.ID">
          <div class="a-left">
            <div style="display: flex">
              {{ item.FactorName }}
              <span class="gs" v-if="item.yzType === 4">公式</span>
              <span class="gs" v-if="item.yzType === 6">自然</span>
              <span class="gs" v-if="item.yzType === 2">拖拽</span>
            </div>

            <p class="XiFenZhongLei">{{ item.XiFenZhongLei || item.SubClassName }}</p>
          </div>

          <div class="a-right">
            <div
              v-if="item.yzType == 0"
              style="display: flex; justify-content: space-between; width: 70%"
            >
              <p :class="[judgeColor(item.RiZhangFu)]">
                {{ toFixedNum(item.RiZhangFu * 100, 2, '%') }}
              </p>
              <p class="zhi">{{ item.XinHaoShuLiang || 0 }}只</p>
            </div>

            <div v-else></div>

            <img src="@/assets/image/sc.png" alt="" @click.stop="delYz(item)" />
          </div>
        </li>
      </ul>

      <p v-else class="null">暂无添加的因子</p>
    </van-action-sheet> -->

        <!-- 点击卡片显示的信息 -->
        <div class="card">
            <van-popup v-model="showCard" round position="bottom" style="min-height: 30%">
                <div class="popup_body">
                    <p class="title">{{ cardMsg.FactorName }}</p>

                    <div class="background">
                        <van-row v-if="cardMsg.yzType == 0">
                            <van-col span="6">
                                <span class="label"> 今日涨幅: </span>
                            </van-col>
                            <van-col span="6">
                                <p :class="[judgeColor(cardMsg.RiZhangFu)]">
                                    {{ toFixedNum(cardMsg.RiZhangFu * 100, 2, '%') }}
                                </p>
                            </van-col>

                            <van-col span="6">
                                <span class="label">今日信号数:</span>
                            </van-col>
                            <van-col span="6">
                                <p class="zhi">{{ cardMsg.XinHaoShuLiang || 0 }}只</p>
                            </van-col>
                        </van-row>

                        <van-row>
                            <van-col span="6">
                                <span class="label">所属分类:</span>
                            </van-col>
                            <van-col span="18">
                                <span
                                    class="XiFenZhongLei"
                                    v-if="
                                        SubClassName != '自选因子' && SubClassName != '自定义因子'
                                    "
                                    >{{ cardMsg.ClassName }}-{{ cardMsg.XiFenZhongLei }}</span
                                >
                                <span class="XiFenZhongLei" v-else> {{ SubClassName }}</span>
                            </van-col>
                        </van-row>

                        <van-row>
                            <van-col span="6">
                                <span class="label">因子描述:</span>
                            </van-col>
                            <van-col span="18">
                                <span class="Desc"> {{ cardMsg.Desc }} </span>
                            </van-col>
                        </van-row>
                    </div>

                    <div class="btn">
                        <button class="cancel" @click="showCard = false">取消</button>
                        <button
                            class="add"
                            @click.stop="addYz(cardMsg), (showCard = false)"
                            v-if="!checkIDExists(checkedYzList, cardMsg.ID)"
                        >
                            添加到因子组合池
                        </button>

                        <button class="add" @click.stop="delYz(cardMsg), (showCard = false)" v-else>
                            移出因子组合池
                        </button>
                    </div>
                </div>
            </van-popup>
        </div>

        <!-- 选择因子类型 -->

        <div class="yzPopup">
            <van-popup v-model="isShowPicker" round position="bottom" :get-container="getContainer">
                <van-picker
                    title="选择因子类型"
                    show-toolbar
                    :columns="columns"
                    @confirm="onConfirm"
                    @cancel="onCancel"
                    :default-index="defaultIndex"
                />
            </van-popup>
        </div>
    </div>
</template>

<script>
import mixin from '@/mixins/index.js';
import { mapMutations } from 'vuex';
import merge from 'webpack-merge';
import {
    judgeColor,
    toFixedNum,
    removeValueFromArray,
    strToHexCharCode,
    deepCopy,
    compareVersions,
    factorCombinationToCode
} from '@/utils/format';
import {
    getClassAll,
    getFactorListByClassId,
    getFactorHq,
    getDayStockPool,
    getMergeIndividuation,
    getTemplateFactor,
    getMyStockInfo,
    getMyCustomFactor,
    getFactorListIsVip,
    getDictionaryHotFactor
} from '@/api/create.js';
import { Base64 } from 'js-base64';
// import inobounce from 'inobounce'; //处理ios橡皮筋

export default {
    name: 'CheckedYz',
    mixins: [mixin],
    data() {
        return {
            defaultIndex: 0,
            isShowPicker: false,
            columns: ['A股因子', 'ETF因子'],
            activeKey: 0,
            loading: false,
            finished: false,
            navList: [],
            page: 1,
            ClassId: null,
            inishedText: '加载中...',
            // checkedYzList: [],
            showActionSheet: false,
            resultNum: 0,
            isResultLoading: false,
            childrenList: [],
            subclassid: 0,
            SubClassName: '',
            showCard: false,
            cardMsg: {},
            zfSort: 1,
            xhsSort: 0,
            desc: true,
            orderby: 'rizhangfu',
            navIndex: 0,
            factorListByClassIdList: [],
            mergedArray: [],
            ProductType: null,
            isVip: false,
            maxLines: 2, // 最大行数
            initialFontSize: 16, // 初始字体大小（以像素为单位）
            num: 50,
            newPage: 0,
            tabDisabled: false,
            // 选中的因子数量
            checkedYzNum: 0
        };
    },
    components: {},
    filters: {},
    created() {
        // let u = navigator.userAgent;
        // if (u.indexOf('iPhone') > -1) {
        //   inobounce.enable();
        // }
        // if (window.DzhAppJs) {
        //   DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc('', 'true', 'interceptOnKeyDown'); //安卓里面禁用返回功能
        // }

        // 检查是否是策略广场进来的
        if (this.$route.query.mark === 'clgc') {
            this.resetState(); //重置部分vuex
        }
    },
    watch: {
        totalSelectedCount(newVal) {
            this.checkedYzNum = newVal;
        },
        '$store.state.isVip': {
            handler(newValue) {
                this.isVip = newValue;
            },
            immediate: true // 立即执行一次
        },
        checkedYzList: {
            handler() {
                //修改原有参数--5.1节后打开
                // this.$router.push({
                //   query: merge(this.$route.query, { dtzhHcCheckedYzList: '', dtzhCheckedYzList: '' })
                // });

                console.log('this.checkedYzList==2', this.checkedYzList);

                this.$store.commit('setCheckedYzList', this.checkedYzList); // 提交 mutation 来更新全局状态

                this.checkedYzNumStatic();

                // 调用动态组合选股
                this.isDtzhSelectStock();
            },
            deep: true
        },
        groupYzList: {
            handler(newVal) {
                console.log('父组件监听到变化了', newVal);
                // 如果你需要把 Vuex 的数据同步回组件内的 unionGroups
                // 只有当 isInternalSync 为 false 时才同步，避免循环更新
                if (!this.isInternalSync) {
                    this.unionGroups = JSON.parse(JSON.stringify(newVal));
                }
                this.checkedYzNumStatic();
            },
            deep: true
        }
    },

    //计算属性
    computed: {
        contentNavBar: function () {
            return this.$store.state.contentNavBar; // 获取全局状态
        },
        Obj: function () {
            return this.$store.state.Obj; // 获取全局状态
        },
        publicHcID: function () {
            return this.$store.state.publicHcID; // 获取vuex的id 要是存在id走编辑逻辑
        },
        groupYzList() {
            return this.$store.state.groupYzList;
        },
        checkedYzList() {
            return this.$store.state.checkedYzList;
        },
        checkedYzType() {
            return this.$store.state.checkedYzType;
        }
    },
    async mounted() {
        this.$store.commit('setBtnDisabled', false);

        //如果是app客户端试试量化跳转过来的就拿url的checkedYzList参数来操作
        //如果app点击是矢量化回测跳转过来的话url存在checked参数那么就是969+的版本反之就是698的版本(两者的创建逻辑有区别)

        if (this.$route.query.checkedYzList) {
            let c = JSON.parse(this.decodeUrlParameter(this.$route.query.checkedYzList));
            // 遍历数组并根据yzType修改Info字段
            for (var i = 0; i < c.length; i++) {
                if (c[i].yzType == 3) {
                    // 删除Info字段前两位和后一位
                    c[i].Info = c[i].Info.substring(2, c[i].Info.length - 1);
                }
            }
            this.$store.commit('setCheckedYzList', c);
            if (!this.$route.query.publicHcID) {
                this.$store.commit('resetPublicHcID');
                this.$store.commit('resetType');
            }
        }

        //如果是app 动态组合点击编辑过来的走这里
        if (this.$route.query.dtzhCheckedYzList) {
            let c = JSON.parse(this.decodeUrlParameter(this.$route.query.dtzhCheckedYzList));
            console.log('ccccccccccccccc',c);

            this.$store.commit('setCheckedYzList', c);
            if (!this.$route.query.publicHcID) {
                this.$store.commit('resetType');
                this.$store.commit('resetPublicHcID');
            }
        }

        // 解析 groupYzList（因子交并集分组数据）
        if (this.$route.query.groupYzList) {
            let groupList = JSON.parse(this.decodeUrlParameter(this.$route.query.groupYzList));
            console.log('groupYzList', groupList);
            this.$store.commit('setGroupYzList', groupList);
        }

        // 解析 checkedYzType（交并集类型：jj=交集，bj=并集）
        if (this.$route.query.checkedYzType) {
            console.log('checkedYzType', this.$route.query.checkedYzType);
            this.$store.commit('setCheckedYzType', this.$route.query.checkedYzType);
        }

        // 如果是app 动态组合点击回测走这里
        if (this.$route.query.dtzhHcCheckedYzList) {
            let c = JSON.parse(this.decodeUrlParameter(this.$route.query.dtzhHcCheckedYzList));
            this.$store.commit('setCheckedYzList', c);
            // 如果 url 中没有带 resetPublicHcID 意味着就是第一次来的 就清除掉 resetPublicHcID  否则就不改变逻辑
            if (!this.$route.query.publicHcID) {
                this.$store.commit('resetType');
                this.$store.commit('resetPublicHcID');
            }
        }

        // 如果是app 自选组合(自选股)中点击回测走这里
        if (this.$route.query.zxgHcCheckedYzList) {
            let c = JSON.parse(this.decodeUrlParameter(this.$route.query.zxgHcCheckedYzList));
            console.log('c', c);

            this.$store.commit('setCheckedYzList', c);
            // 如果 url 中没有带 resetPublicHcID 意味着就是第一次来的 就清除掉 resetPublicHcID  否则就不改变逻辑
            if (!this.$route.query.publicHcID) {
                this.$store.commit('resetPublicHcID');
                this.$store.commit('resetType');
            }
        }

        // this.checkedYzList = this.$store.state.checkedYzList || [];  <-- 删除这行，不要覆盖计算属性
        if (this.$route.query.dtzhCheckedYzList && this.$store.state.checkedYzList.length) {
            this.ProductType = this.$store.state.checkedYzList[0].ProductType;
        }
        if (this.$route.query.yzType == 'ETF' || this.ProductType == 'ETF') {
            this.defaultIndex = 1;
        } else {
            this.defaultIndex = 0;
        }

        this.getClassAllFun();
        this.checkedYzNumStatic();
        this.isDtzhSelectStock();
    },
    beforeDestroy() {
        // inobounce.disable();
    },
    methods: {
        ...mapMutations(['resetState']),
        judgeColor,
        toFixedNum,
        compareVersions,
        //将URL参数中的 * 替换为 +，- 替换为 /，. 替换为 =，然后进行Base64解码
        decodeUrlParameter: function (encodedUrl) {
            var replacedString = encodedUrl
                .replace(/\*/g, '+')
                .replace(/-/g, '/')
                .replace(/\./g, '=');

            var decodedString = Base64.decode(replacedString);
            return decodedString;
        },
        //将数据进行Base64编码，+ 替换为 *，/ 替换为 -，= 替换为 .
        encodeUrlParameter: function (data) {
            var jsonString = JSON.stringify(data);
            var encodedString = Base64.encode(jsonString);
            var replacedString = encodedString
                .replace(/\+/g, '*')
                .replace(/\//g, '-')
                .replace(/=/g, '.');
            return replacedString;
        },
        handleClickSelYzType() {
            this.isShowPicker = true;
        },

        getSpanWidths() {
            this.$nextTick(() => {
                for (let i = this.page - 1; i < this.page - 1 + this.num; i++) {
                    if (this.$refs[`pElementsSpan_${i}`]) {
                        const spanWidth = this.$refs[`pElementsSpan_${i}`][0].offsetWidth;
                        this.mergedArray[i].spanWidth = spanWidth;
                    }
                }

                this.$forceUpdate();
            });
        },

        getSpanWidths2() {
            this.$nextTick(() => {
                for (let i = 0; i < this.num; i++) {
                    if (this.$refs[`pElementsSpan2_${i}`]) {
                        const spanWidth = this.$refs[`pElementsSpan2_${i}`][0].offsetWidth;
                        this.mergedArray[i].spanWidth = spanWidth;
                    }
                }

                this.$forceUpdate();
            });
        },

        //点击完成按钮时触发
        onConfirm(value, index) {
            this.$dialog
                .confirm({
                    confirmButtonText: '切换',
                    confirmButtonColor: '#286DF7',
                    cancelButtonText: '取消',
                    cancelButtonColor: '#286DF7',
                    message: '切换因子类型后，所选的因子池将会清空，是否确定切换？'
                })
                .then(() => {
                    // 直接修改当前路由的参数
                    this.$store.commit('resetState');
                    this.checkedYzList = [];
                    this.defaultIndex = index;
                    this.isShowPicker = false;

                    if (index == 1) {
                        this.$router.push({
                            query: merge(this.$route.query, {
                                yzType: 'ETF'
                            })
                        });
                    } else {
                        this.$router.push({
                            query: merge(this.$route.query, {
                                yzType: 'A'
                            })
                        });
                    }

                    // location.reload();
                    this.page = 1;
                    this.mergedArray = [];
                    this.factorListByClassIdList = [];

                    this.getClassAllFun();
                })
                .catch(() => {
                    // on cancel
                });
        },
        onCancel() {
            this.isShowPicker = false;
        },
        //当日股池
        getDayStockPoolFun: function (yzIds) {
            let _this = this;
            _this.isResultLoading = true;
            var params = {
                factorIDs: yzIds, //string 因子id组，逗号分隔,如：单个因子时factorIDs=Id1，多因子 factorIDs=Id1,Id2,Id3,Id4
                start: 1,
                count: 1,
                desc: true, //排序方式, 可选项包括:false(升序),true(降序)
                field: 'ZhangFu' //排序字段,*表示必填,可选项见表后说明,排序字段只能从field可选项中任选其一
            };
            getDayStockPool(params)
                .then((res) => {
                    _this.isResultLoading = false;
                    _this.resultNum = res.data.ObjCount || 0;
                })
                .catch((err) => {
                    _this.isResultLoading = false;
                    _this.$toast(err);
                });
        },

        //行情
        getFactorHqFun: function (yzIds) {
            var params = {
                type: 'yz',
                factorID: yzIds,
                field: 'HuoYueDu,Desc'
            };
            getFactorHq(params)
                .then((res) => {
                    this.checkedYzList = res.data;
                    this.$store.commit('setCheckedYzList', res.data);
                })
                .catch((err) => {
                    this.$toast(err);
                });
        },

        //初始化无限加载数据
        listFun: function () {
            if (this.childrenList[0].ClassName == '推荐') {
                this.getDictionaryHotFactorFun(1);
            } else {
                this.getFactorListByClassIdFun();
            }
        },

        //获取分类跟子分类
        getClassAllFun: function () {
            this.loading = true;
            var params = {
                productType: this.defaultIndex == 0 ? '' : 'etf'
            };
            getClassAll(params)
                .then((res) => {
                    this.navList = res.data;
                    this.ClassId = res.data[0].ClassId;
                    this.childrenList = res.data[0].children;
                    this.subclassid = ''; //res.data[0].children[0].SubClassId;

                    if (this.childrenList[0].ClassName != '推荐') {
                        this.childrenList.unshift({
                            ClassId: 'all',
                            ClassName: '全部',
                            SubClassId: 'all',
                            SubClassName: '全部'
                        });
                    } else if (
                        this.childrenList[0].ClassName != '推荐' &&
                        this.childrenList[0].ClassName != '个性化' &&
                        this.childrenList[0].ClassName != '调优模版'
                    ) {
                        this.childrenList.unshift({
                            ClassId: 500,
                            ClassName: '常用',
                            SubClassId: 500,
                            SubClassName: '常用'
                        });
                    }

                    this.SubClassName = res.data[0].children[0].SubClassName;

                    this.listFun();
                })
                .catch((err) => {
                    this.loading = false;
                });
        },

        //点击一级分类
        handleClickNav: async function (i) {
            if (i === this.navIndex) return false;
            this.tabDisabled = true;
            this.finished = false;
            this.navIndex = i;
            this.loading = true;
            this.page = 1;
            this.mergedArray = [];
            this.factorListByClassIdList = [];
            this.activeKey = 0;
            this.ClassId = this.navList[i].ClassId;
            this.childrenList = [];
            this.childrenList = this.navList[i].children;
            this.subclassid = this.childrenList[0].SubClassId;

            if (this.ClassId === 9999) {
                //如果是个性化
                await this.getMyStockInfoFun();
            } else if (this.ClassId === 9998) {
                await this.getTemplateFactorFun();
            } else if (this.ClassId === 10001) {
                await this.getDictionaryHotFactorFun(1);
            } else {
                var hasAllSubClass = this.childrenList.some(function (item) {
                    return item.SubClassId === 'all';
                });

                if (!hasAllSubClass) {
                    this.childrenList.unshift({
                        ClassId: 'all',
                        ClassName: '全部',
                        SubClassId: 'all',
                        SubClassName: '全部'
                    });
                }

                var SubClass = this.childrenList.some(function (item) {
                    return (
                        item.ClassName == '推荐' ||
                        item.ClassName == '个性化' ||
                        item.ClassName == '调优模版' ||
                        item.ClassName == '常用'
                    );
                });

                if (!SubClass) {
                    this.childrenList.unshift({
                        ClassId: 500,
                        ClassName: '常用',
                        SubClassId: 500,
                        SubClassName: '常用'
                    });
                    this.subclassid = 500;
                }
                await this.getFactorListByClassIdFun();
            }

            this.SubClassName = this.childrenList[0].SubClassName;

            setTimeout(() => {
                this.tabDisabled = false;
            }, 500);
        },

        //点击左侧导航
        handleClickTabs: async function (e) {
            this.tabDisabled = true;
            this.page = 1;
            if (this.childrenList[e].SubClassId != this.subclassid) {
                this.inishedText = '加载中...';
                this.loading = true;
                this.mergedArray = [];
                this.factorListByClassIdList = [];

                if (this.childrenList[e].SubClassId === 'all') {
                    this.subclassid = '';
                } else {
                    this.subclassid = this.childrenList[e].SubClassId;
                }

                this.SubClassName = this.childrenList[e].SubClassName;

                if (this.ClassId == 9999) {
                    if (this.SubClassName == '自选因子') {
                        await this.getMyStockInfoFun();
                    } else if (this.SubClassName == '自定义因子') {
                        await this.getMyCustomFactorFun();
                    }
                } else if (this.ClassId == 9998) {
                    await this.getTemplateFactorFun();
                } else if (this.ClassId == 10001) {
                    let type;
                    if (this.SubClassName == '热门因子') {
                        type = 1;
                    } else if (this.SubClassName == '热门使用') {
                        type = 2;
                    } else if (this.SubClassName == '最近浏览') {
                        type = 3;
                    } else if (this.SubClassName == '我的关注') {
                        type = 5;
                    }
                    await this.getDictionaryHotFactorFun(type);
                } else {
                    await this.getFactorListByClassIdFun();
                }
            }

            setTimeout(() => {
                this.tabDisabled = false;
            }, 400);
        },

        //获取我的自选因子
        getMyStockInfoFun: function () {
            this.inishedText = '加载中...';

            getMyStockInfo({})
                .then((res) => {
                    this.mergedArray = res.data;
                    this.$toast.clear();
                    this.loading = false;

                    if (res.data.length === 0) {
                        this.finished = true;
                        if (
                            this.$route.query.source === 'dtzh' ||
                            this.$route.query.dtzhCheckedYzList
                        ) {
                            this.inishedText = '当前分类下暂无因子';
                        } else {
                            this.inishedText = '当前分类下暂无可回测因子';
                        }

                        return false;
                    }

                    if (res.data.length >= 50) {
                        this.finished = false;
                        this.inishedText = '加载中...';
                    } else {
                        this.finished = true;
                        this.inishedText = '没有更多了';
                    }

                    this.num = res.data.length || 1;
                    this.getSpanWidths2();
                })
                .catch((err) => {
                    this.$toast.clear();
                    this.loading = false;
                    if (
                        this.$route.query.source === 'dtzh' ||
                        this.$route.query.dtzhCheckedYzList
                    ) {
                        this.inishedText = '当前分类下暂无因子';
                    } else {
                        this.inishedText = '当前分类下暂无可回测因子';
                    }
                });
        },

        //获取我的自定义因子
        getMyCustomFactorFun: function () {
            this.inishedText = '加载中...';

            getMyCustomFactor({
                start: 1,
                count: 300
            })
                .then((res) => {
                    this.mergedArray = res.data.listData || [];
                    this.$toast.clear();
                    this.loading = false;

                    if (res.data.length === 0) {
                        this.finished = true;
                        if (
                            this.$route.query.source === 'dtzh' ||
                            this.$route.query.dtzhCheckedYzList
                        ) {
                            this.inishedText = '当前分类下暂无因子';
                        } else {
                            this.inishedText = '当前分类下暂无可回测因子';
                        }

                        return false;
                    } else {
                        this.finished = true;
                        this.inishedText = '没有更多了';
                    }

                    this.num = res.data.listData.length || 0;
                    this.getSpanWidths2();
                })
                .catch((err) => {
                    this.$toast.clear();
                    this.loading = false;
                    if (
                        this.$route.query.source === 'dtzh' ||
                        this.$route.query.dtzhCheckedYzList
                    ) {
                        this.inishedText = '当前分类下暂无因子';
                    } else {
                        this.inishedText = '当前分类下暂无可回测因子';
                    }
                });
        },

        //获取个性化数据
        // getMergeIndividuationFun: function () {
        //   this.inishedText = '加载中...';

        //   getMergeIndividuation({})
        //     .then((res) => {
        //       this.mergedArray = res.data;
        //       this.$toast.clear();
        //       this.loading = false;

        //       if (res.data.length === 0) {
        //         this.finished = true;
        //         if (this.$route.query.source === 'dtzh' || this.$route.query.dtzhCheckedYzList) {
        //           this.inishedText = '当前分类下暂无因子';
        //         } else {
        //           this.inishedText = '当前分类下暂无可回测因子';
        //         }

        //         return false;
        //       }

        //       if (res.data.length >= 50) {
        //         this.finished = false;
        //         this.inishedText = '加载中...';
        //       } else {
        //         this.finished = true;
        //         this.inishedText = '没有更多了';
        //       }
        //     })
        //     .catch((err) => {
        //       this.$toast.clear();
        //       this.loading = false;
        //       if (this.$route.query.source === 'dtzh' || this.$route.query.dtzhCheckedYzList) {
        //         this.inishedText = '当前分类下暂无因子';
        //       } else {
        //         this.inishedText = '当前分类下暂无可回测因子';
        //       }
        //     });
        // },

        //获取调优模版数据
        getTemplateFactorFun: function () {
            this.inishedText = '加载中...';

            getTemplateFactor({
                page: 1,
                limit: 99
            })
                .then((res) => {
                    this.mergedArray = res.data;
                    this.$toast.clear();
                    this.loading = false;

                    if (res.data.length === 0) {
                        this.finished = true;
                        if (
                            this.$route.query.source === 'dtzh' ||
                            this.$route.query.dtzhCheckedYzList
                        ) {
                            this.inishedText = '当前分类下暂无因子';
                        } else {
                            this.inishedText = '当前分类下暂无可回测因子';
                        }

                        return false;
                    }

                    if (res.data.length >= 50) {
                        this.finished = false;
                        this.inishedText = '加载中...';
                    } else {
                        this.finished = true;
                        this.inishedText = '没有更多了';
                    }

                    this.num = res.data.length || 1;
                    this.getSpanWidths2();
                })
                .catch((err) => {
                    this.$toast.clear();
                    this.loading = false;
                    if (
                        this.$route.query.source === 'dtzh' ||
                        this.$route.query.dtzhCheckedYzList
                    ) {
                        this.inishedText = '当前分类下暂无因子';
                    } else {
                        this.inishedText = '当前分类下暂无可回测因子';
                    }
                });
        },

        //判断当前因子是否选中
        checkIDExists: function (dataList, id) {
            for (let i = 0; i < dataList.length; i++) {
                if (dataList[i].ID == id) {
                    return true;
                }
            }

            // 检查 groupYzList (并集组合)
            if (this.groupYzList && this.groupYzList.length) {
                for (let i = 0; i < this.groupYzList.length; i++) {
                    let group = this.groupYzList[i];
                    if (Array.isArray(group)) {
                        for (let j = 0; j < group.length; j++) {
                            // 兼容 ID
                            if (group[j].ID == id) {
                                return true;
                            }
                        }
                    }
                }
            }

            return false;
        },

        //点击卡片显示描述等信息
        handleClickCard: function (item) {
            // if (this.ClassId != 9999 && this.ClassId != 9998) {
            this.showCard = true;
            this.cardMsg = item;
            // }
        },

        //点击添加因子 +
        addYz: function (item) {
            //   if(this.isVip == false && compareVersions(this.$route.query.version , 9.92)) {
            //     let appJson = {
            //       DialogType: "basic",
            //     };
            //     DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
            //       'factorTYPerDialog',
            //       JSON.stringify(appJson),
            //       ''
            //     );
            //     return false;
            //   } else if (this.isVip == false && compareVersions(this.$route.query.version , 9.71) && item.ExtendType) {
            //     const appJsonTypeData = {
            //       channel: 'yinzi',
            //       dzhadid: '0807'
            //     };

            //     // 如果不是VIP用户,弹出VIP提示
            //     // 调用客户端js 弹窗
            //     window.DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
            //       'factorNoVipPerDialog',
            //       JSON.stringify(appJsonTypeData),
            //       ''
            //     );

            //     return false;
            //   }

            if (this.checkedYzNum >= 10) {
                this.$toast('最多添加10个因子');

                return false;
            }

            // 使用 Vuex mutation 来修改 checkedYzList
            let list = [...this.checkedYzList, item];
            this.$store.commit('setCheckedYzList', list);
        },
        //删除选中的因子 -
        delYz: function (item) {
            // 复制一份数据进行操作
            let list = [...this.checkedYzList];
            if (item.yzType == 0) {
                removeValueFromArray(list, item.ID);
            } else {
                removeValueFromArray(list, item.Info);
            }
            this.$store.commit('setCheckedYzList', list);
        },
        //清空选中的因子
        handleClear: function () {
            this.$store.commit('resetCheckedYzList');
            this.showActionSheet = false;
        },

        //跳转选择参数页面
        goArguments: function () {
            // this.$store.commit('resetObj');
            // this.$store.commit('resetPublicHcID');

            //   校验组合中是否大于一个
            if (!this.checkGroupLength()) {
                return false;
            }

            if (
                this.$route.query.source === 'dyzcl' ||
                this.$route.query.source == 'appDyzHc' ||
                this.$route.query.source === 'appCl'
            ) {
                const query = {
                    token: this.$route.query.token || '',
                    mySource: this.$route.query.mySource,
                    source: this.$route.query.source,
                    themeStyleVs: this.$route.query.themeStyleVs || 0,
                    version: this.$route.query.version || '',
                    yzType:
                        this.$route.query.yzType == 'ETF' && this.defaultIndex == 1 ? 'ETF' : 'A',
                    createType: this.$route.query.createType || '',
                    dtzhHcCheckedYzList: this.$route.query.dtzhHcCheckedYzList || '',
                    dtzhCheckedYzList: this.$route.query.dtzhCheckedYzList || ''
                };

                this.$router.push({
                    path: '/dyzArguments',
                    name: 'DyzArguments',
                    query: query
                });
            } else if (
                this.$route.query.source === 'lhcl' ||
                this.$route.query.checkedYzList ||
                this.$route.query.source == 'appLhHc'
            ) {
                const query = {
                    token: this.$route.query.token || '',
                    type: this.getUrlQuery('type') ? this.getUrlQuery('type') : '',
                    mySource: this.$route.query.mySource,
                    source: this.$route.query.source || 'lhcl',
                    themeStyleVs: this.$route.query.themeStyleVs || 0,
                    version: this.$route.query.version || '',
                    yzType:
                        this.$route.query.yzType == 'ETF' && this.defaultIndex == 1 ? 'ETF' : 'A',
                    createType: this.$route.query.createType || '',
                    factorId: this.$route.query.factorId || '',
                    dtzhHcCheckedYzList: this.$route.query.dtzhHcCheckedYzList || '',
                    dtzhCheckedYzList: this.$route.query.dtzhCheckedYzList || '',
                    zxgHcCheckedYzList: this.$route.query.zxgHcCheckedYzList || '',
                    mark: this.$route.query.mark || ''
                };

                if (this.$route.query.checkedYzList) {
                    query.userid = this.$route.query.userid;
                    query.factorid = this.$route.query.factorid;
                    query.factornames = this.$route.query.userid;
                    query.checkedYzList = this.$route.query.checkedYzList;
                    query.zxgType = this.$route.query.zxgType || 0;
                } else if (this.$route.query.userid && !this.$route.query.checkedYzList) {
                    query.userid = this.$route.query.userid;
                    query.factorid = this.$route.query.factorid;
                    query.factornames = this.$route.query.userid;
                    query.zxgType = 0;
                }

                if (this.$route.query.zdyType == '1') {
                    query.zdyType = 1;
                    this.$router.push({
                        path: '/arguments',
                        name: 'arguments',
                        query: query
                    });
                } else {
                    this.$router.push({
                        path: '/lhArguments',
                        name: 'LhArguments',
                        query: query
                    });
                }
            }
        },

        handleClickShowActionSheet: function () {
            this.checkedYzNum > 0 ? (this.showActionSheet = true) : '';

            var filteredIds = [];

            for (var i = 0; i < this.checkedYzList.length; i++) {
                var item = this.checkedYzList[i];
                if (item.yzType == 0) {
                    filteredIds.push(item.ID);
                }
            }

            if (this.checkedYzList.length && filteredIds.length) {
                var params = {
                    type: 'yz',
                    factorID: filteredIds.toString(),
                    field: 'HuoYueDu,Desc'
                };
                getFactorHq(params)
                    .then((res) => {
                        let arr1 = deepCopy(this.$store.state.checkedYzList);
                        let arr2 = res.data;

                        // 使用对象存储arr2中的数据，以ID作为键
                        var arr2Map = {};
                        for (var i = 0; i < arr2.length; i++) {
                            var item = arr2[i];
                            arr2Map[item.ID] = item;
                        }

                        // 遍历arr1并在arr2Map中查找匹配的数据
                        for (var i = 0; i < arr1.length; i++) {
                            var item = arr1[i];
                            if (arr2Map[item.ID]) {
                                // 更新匹配对象的字段，保留额外的字段
                                Object.assign(arr1[i], arr2Map[item.ID]);
                            }
                        }

                        // this.checkedYzList = arr1;
                        this.$store.commit('setCheckedYzList', arr1);
                    })
                    .catch((err) => {
                        this.$toast(err);
                    });
            }
        },

        //跳转查看今日股票列表页
        goDtzhPreview: function () {
            let query;

            //   校验组合中是否大于一个
            if (!this.checkGroupLength()) {
                return false;
            }

            if (this.$route.query.dtzhCheckedYzList) {
                query = {
                    token: this.$route.query.token || '',
                    mySource: this.$route.query.mySource,
                    source: this.$route.query.source,
                    themeStyleVs: this.$route.query.themeStyleVs || 0,
                    version: this.$route.query.version || '',
                    dtzhCheckedYzList: this.$route.query.dtzhCheckedYzList || '',
                    groupYzList: this.groupYzList.length ? this.encodeUrlParameter(this.groupYzList) : '',
                    checkedYzType: this.checkedYzType || '',
                    id: this.$route.query.id || '',
                    name: this.$route.query.name || '',
                    yzType:
                        this.$route.query.yzType == 'ETF' && this.defaultIndex == 1 ? 'ETF' : 'A',
                    factorId: this.$route.query.factorId || ''
                };
            } else {
                query = {
                    token: this.$route.query.token || '',
                    mySource: this.$route.query.mySource,
                    source: this.$route.query.source,
                    themeStyleVs: this.$route.query.themeStyleVs || 0,
                    version: this.$route.query.version || '',
                    yzType:
                        this.$route.query.yzType == 'ETF' && this.defaultIndex == 1 ? 'ETF' : 'A',
                    factorId: this.$route.query.factorId || ''
                };
            }

            this.$router.push({
                path: '/dtzh-preview',
                name: 'Dtzh-preview',
                query: query
            });
        },

        goSelectYz: function () {
            const query = {
                token: this.$route.query.token || '',
                source: this.$route.query.source,
                themeStyleVs: this.$route.query.themeStyleVs || 0,
                version: this.$route.query.version || '',
                yzType: this.$route.query.yzType == 'ETF' && this.defaultIndex == 1 ? 'ETF' : 'A',
                mySource: this.$route.query.mySource || '',
                createType: this.$route.query.createType || '',
                factorId: this.$route.query.factorId || '',
                mark: this.$route.query.mark || ''
            };

            if (this.$route.query.checkedYzList) {
                query.userid = this.$route.query.userid;
                query.factorid = this.$route.query.factorid;
                query.factornames = this.$route.query.userid;
                query.checkedYzList = this.$route.query.checkedYzList;
                query.zxgType = this.$route.query.zxgType || 0;
                query.source = 'lhcl';
            } else if (this.$route.query.userid && !this.$route.query.checkedYzList) {
                query.userid = this.$route.query.userid;
                query.factorid = this.$route.query.factorid;
                query.factornames = this.$route.query.userid;
                query.zxgType = 0;
            } else if (this.$route.query.dtzhCheckedYzList) {
                query.source = 'dtzh';
                query.dtzhCheckedYzList = this.$route.query.dtzhCheckedYzList;
                query.groupYzList = this.groupYzList.length ? this.encodeUrlParameter(this.groupYzList) : '';
                query.checkedYzType = this.checkedYzType || '';
                query.id = this.$route.query.id;
                query.name = this.$route.query.name;
            }

            if (this.$route.query.zdyType == '1') {
                query.zdyType = 1;
            }

            this.$router.push({
                path: '/selectYz',
                name: 'SelectYz',
                query: query
            });
        },
        close: function () {
            location.href = 'dzh_browser_url&goto=0&screen=263';
        },
        goBack: function () {
            /**
             * ! 这里那种场景下会使用到 go -1 我先注释掉 (王文浩), 暂时修改成 只判断分享
             */
            // if (
            //   this.$route.query.source == 'appDyzHc' ||
            //   this.$route.query.source == 'appLhHc' ||
            //   this.$route.query.source == 'appCl' ||
            //   this.$route.query.menutype == 'share' ||
            //   this.$route.query.shareType
            // ) {
            //   this.$router.go(-1);

            //   return false;
            // }
            if (
                this.$route.query.menutype == 'share' ||
                this.$route.query.shareType ||
                this.$route.query.zdyType
            ) {
                this.$router.go(-1);
                return false;
            }

            if (this.$route.query.mySource === 'myCl') {
                if (compareVersions(this.$route.query.version, 9.73)) {
                    location.href = 'dzh_browser_url&goto=0&screen=230&id=1814';
                } else {
                    this.$router.push({
                        path: '/my',
                        name: 'My',
                        query: {
                            tab: 'cl',
                            token: this.$route.query.token || '',
                            themeStyleVs: this.$route.query.themeStyleVs || 0,
                            version: this.$route.query.version || ''
                        }
                    });
                }
            } else if (this.$route.query.mySource === 'myDyzHc') {
                if (compareVersions(this.$route.query.version, 9.73)) {
                    location.href = 'dzh_browser_url&goto=0&screen=230&id=1818';
                } else {
                    this.$router.push({
                        path: '/my',
                        name: 'My',
                        query: {
                            tab: 'hc',
                            token: this.$route.query.token || '',
                            smallTab: 0,
                            themeStyleVs: this.$route.query.themeStyleVs || 0,
                            version: this.$route.query.version || ''
                        }
                    });
                }
            } else if (this.$route.query.mySource === 'myLhHc') {
                const query = {
                    tab: 'hc',
                    token: this.$route.query.token || '',
                    smallTab: 1,
                    themeStyleVs: this.$route.query.themeStyleVs || 0,
                    version: this.$route.query.version || ''
                };

                if (this.$route.query.checkedYzList) {
                    query.userid = this.$route.query.userid;
                    query.factorid = this.$route.query.factorid;
                    query.factornames = this.$route.query.userid;
                    query.checkedYzList = this.$route.query.checkedYzList;
                } else if (this.$route.query.userid && !this.$route.query.checkedYzList) {
                    query.userid = this.$route.query.userid;
                    query.factorid = this.$route.query.factorid;
                    query.factornames = this.$route.query.userid;
                }
                if (compareVersions(this.$route.query.version, 9.73)) {
                    location.href = 'dzh_browser_url&goto=0&screen=230&id=1818';
                } else {
                    this.$router.push({
                        path: '/my',
                        name: 'My',
                        query: query
                    });
                }
            } else {
                this.$router.push({
                    path: '/create',
                    name: 'Create',
                    query: this.$route.query
                });
            }
        },

        //点击今日涨幅 排序
        handleClickZf: function () {
            this.inishedText = '加载中...';
            // this.loading = true;

            this.xhsSort = 0;
            if (this.zfSort === 2) {
                this.zfSort = 0;
            } else {
                this.zfSort++;
            }

            if (this.zfSort == 1) {
                this.desc = true;
            } else if (this.zfSort == 2) {
                this.desc = false;
            } else {
                this.desc = true;
            }

            this.page = 1;
            this.mergedArray = [];
            this.orderby = 'rizhangfu';
            this.getFactorListByClassIdFun();
        },
        handleClickXhs: function () {
            this.inishedText = '加载中...';
            // this.loading = true;

            this.zfSort = 0;
            if (this.xhsSort === 2) {
                this.xhsSort = 0;
            } else {
                this.xhsSort++;
            }

            if (this.xhsSort == 1) {
                this.desc = true;
            } else if (this.xhsSort == 2) {
                this.desc = false;
            } else {
                this.desc = true;
            }

            this.page = 1;
            this.mergedArray = [];
            this.orderby = 'XinHaoShuLiang';
            this.getFactorListByClassIdFun();
        },

        //合并两个具有相同 ID 的 JSON 数组
        mergeJSONArrays: function (arr1, arr2) {
            const mergedArray = [];

            // 将arr1中的所有对象添加到mergedArray中
            arr1.forEach((item) => {
                const matchingItem = arr2.find((obj) => obj.ID == item.ID);
                if (matchingItem) {
                    // 如果在arr2中找到相同ID的对象，合并它们并添加到mergedArray中
                    const mergedItem = { ...item, ...matchingItem };
                    mergedArray.push(mergedItem);
                } else {
                    // 如果在arr2中找不到相同ID的对象，直接添加到mergedArray中
                    mergedArray.push(item);
                }
            });

            // 将arr2中在arr1中没有的对象添加到mergedArray中
            arr2.forEach((item) => {
                const isDuplicate = mergedArray.some((obj) => obj.ID == item.ID);
                if (!isDuplicate) {
                    mergedArray.push(item);
                }
            });

            return mergedArray;
        },

        //获取因子列表
        getFactorListByClassIdFun: function () {
            this.finished = true;
            this.inishedText = '加载中...';
            var params = {
                classid: this.ClassId, //int一级分类ID
                subclassid: this.subclassid, //int二级分类ID
                limit: 50, //int获取的条数 : 默认50
                page: this.page, //int获取页数 : 默认1
                backtestType:
                    this.$route.query.source === 'dtzh' || this.$route.query.dtzhCheckedYzList
                        ? ''
                        : '1,2', //String是否展示可回测 默认: 空  查询可回测因子参数: 1,2
                desc: this.desc, //true 降序  false 升序
                orderby: this.subclassid == 500 ? '' : this.orderby //string:'',//是否排序，支持涨幅,信号数量 ,如orderby=rizhangfu  or orderby=XinHaoShuLiang
            };
            getFactorListByClassId(params)
                .then(async (res) => {
                    this.factorListByClassIdList = res.data;
                    this.num = res.data.length;

                    let ids = [];
                    res.data.forEach((e) => {
                        ids.push(e.ID);
                    });

                    if (this.defaultIndex == 0) {
                        //A股
                        this.num = res.data.length;
                        this.getFactorListIsVipFun(ids.toString());
                    } else if (this.defaultIndex == 1) {
                        //ETF
                        this.$toast.clear();
                        this.loading = false;
                        this.mergedArray.push(...this.factorListByClassIdList);
                        await this.getSpanWidths();
                        if (res.data.length >= 50) {
                            this.page += 50;
                            this.num += 50;
                            this.finished = false;
                            this.inishedText = '加载中...';
                        } else {
                            this.num = res.data.length;
                            this.finished = true;
                            this.inishedText = '已加载全部';
                        }
                    }
                })
                .catch(() => {
                    this.$toast.clear();
                    this.loading = false;
                    this.finished = true;
                    if (
                        this.$route.query.source === 'dtzh' ||
                        this.$route.query.dtzhCheckedYzList
                    ) {
                        this.inishedText = '当前分类下暂无因子';
                    } else {
                        this.inishedText = '当前分类下暂无可回测因子';
                    }
                });
        },

        //获取一级分类推荐下面的热门因子/热门使用/最近浏览的数据
        getDictionaryHotFactorFun: function (type) {
            var params = {
                type: type, //获取类型 1-热门因子 2 热门使用因子 3最近浏览因子
                status: this.defaultIndex == 0 ? 'A' : 'ETF', //A - A股类型 ETF- ETF类型
                backtest: this.$route.query.source == 'dtzh' ? 2 : 1 //1-只有可回测因子 2-所有因子 (创组合 展示所有因子)
            };
            getDictionaryHotFactor(params)
                .then((res) => {
                    this.factorListByClassIdList = res.data;
                    this.num = res.data.length || 1;

                    let ids = [];
                    res.data.forEach((e) => {
                        ids.push(e.ID);
                    });
                    //如果是A股
                    if (this.defaultIndex == 0) {
                        if (ids.length) {
                            this.getFactorListIsVipFun(ids.toString());
                        } else {
                            this.$toast.clear();
                            this.loading = false;
                            this.finished = true;
                            this.inishedText = '当前分类下暂无因子';
                        }
                        //如果是ETF
                    } else if (this.defaultIndex == 1) {
                        if (ids.length) {
                            this.$toast.clear();
                            this.loading = false;
                            this.finished = true;
                            this.mergedArray.push(...this.factorListByClassIdList);
                            this.inishedText = '已加载全部';
                            this.getSpanWidths();
                        } else {
                            this.$toast.clear();
                            this.loading = false;
                            this.finished = true;
                            this.inishedText = '当前分类下暂无因子';
                        }
                    }
                })
                .catch(() => {
                    this.$toast.clear();
                    this.loading = false;
                    this.finished = true;
                    this.inishedText = '当前分类下暂无因子';
                });
        },

        //查询是否是vip因子
        getFactorListIsVipFun: function (factorsList) {
            this.finished = true;

            getFactorListIsVip({
                factors: factorsList
            })
                .then(async (res) => {
                    this.$toast.clear();
                    this.loading = false;
                    this.num = res.data.length || 1;

                    if (res.data.length === 0) {
                        this.finished = true;

                        if (
                            this.$route.query.source === 'dtzh' ||
                            this.$route.query.dtzhCheckedYzList
                        ) {
                            this.inishedText = '当前分类下暂无因子';
                        } else {
                            this.inishedText = '当前分类下暂无可回测因子';
                        }

                        return false;
                    }

                    let d = this.mergeJSONArrays(this.factorListByClassIdList, res.data);
                    this.mergedArray.push(...d);

                    await this.getSpanWidths();

                    if (res.data.length >= 50) {
                        this.finished = false;
                        this.inishedText = '加载中...';
                    } else {
                        this.finished = true;
                        this.inishedText = '没有更多了';
                    }

                    this.page += 50;
                })
                .catch((err) => {});
        },
        getContainer() {
            return document.querySelector('.yzPopup');
        },
        // 计算选中的因子
        checkedYzNumStatic() {
            console.log('groupYzList', this.groupYzList);
            console.log('checkedYzList=====', this.checkedYzList);

            const allIDs = this.groupYzList.flat();
            this.checkedYzNum = this.checkedYzList.length + allIDs.length;
        },
        //
        checkSonFactorList() {
            // 使用 filter 过滤掉空数组，并更新 store
            const newList = this.groupYzList.filter((item) => item && item.length > 0);

            if (newList.length !== this.groupYzList.length) {
                this.$store.commit('setGroupYzList', newList);
            }

            this.isDtzhSelectStock();
        },

        // 调用动态组合选股
        isDtzhSelectStock() {
            var _this = this;
            //如果是动态组合  就调用当日股池接口
            if (this.$route.query.source === 'dtzh' || this.$route.query.dtzhCheckedYzList) {
                console.log('_this.checkedYzList', _this.checkedYzList);
                console.log('_this.groupYzList', _this.groupYzList);
                console.log('_this.checkedYzType', _this.checkedYzType);

                // 组合因子交并集
                var hexYzObj = factorCombinationToCode(
                    _this.checkedYzList,
                    _this.groupYzList,
                    _this.checkedYzType
                );
                console.log('hexYzObj', hexYzObj);

                _this.getDayStockPoolFun(hexYzObj.hexyzIds);
            }
        },

        // 校验交集并集组合中只有一个因子的情况
        checkGroupLength() {
            var _this = this;
            for (let i = 0; i < _this.groupYzList.length; i++) {
                const item = _this.groupYzList[i];
                console.log('item', item);
                if (item.length <= 1) {
                    _this.$toast('组合中的因子需要大于1个');
                    return false;
                }
            }
            return true;
        }
    }
};
</script>
<style lang="less" scoped>
.overflowed {
    font-size: px;
}
::v-deep {
    .van-popup {
        z-index: 99995 !important;
    }

    .van-picker__confirm {
        color: #286df7;
    }
}

.yzPopup {
    ::v-deep {
        .van-overlay {
            z-index: 1998 !important;
        }
        .van-popup {
            z-index: 1999 !important;
        }
    }
}

.popup_body {
    padding: 16px;
    .title {
        color: #222;
        font-size: 16px;
        font-weight: 500;
    }
    .background {
        border-radius: 8px;
        background: #f7f7fc;
        padding: 16px;
        margin-top: 19px;
        line-height: 25px;
        .label {
            color: #999;
            font-size: 14px;
        }
        .Desc {
            color: #555;
        }
    }
    .btn {
        padding: 24px 0 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .cancel,
        .add {
            font-size: 16px;
            border-radius: 20px;
            height: 41px;
        }
        .cancel {
            width: 120px;
            border: 1px solid #286df7;
            background: #fff;
            color: #286df7;
        }
        .add {
            width: 215px;
            border: 1px solid #286df7;
            background: #286df7;
            color: #fff;
        }
    }
}
.index-info {
    position: relative;
    .content-nav-bar {
        .pageTitle {
            display: flex;
            align-items: center;
            ::v-deep {
                .van-icon-play {
                    color: #222;
                    font-size: 16px;
                    -ms-transform: rotate(90deg); /* IE 9 */
                    -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
                    -o-transform: rotate(90deg); /* Opera */
                    -moz-transform: rotate(90deg); /* Firefox */
                    transform: rotate(90deg); /* 标准语法 */
                }
            }
        }
    }
    .content {
        .second-level {
            -webkit-overflow-scrolling: touch;
            ::v-deep {
                .van-tabs__wrap {
                    height: 37px;
                    border-bottom: 1px solid #95a1b6;
                }
                .van-tabs__nav {
                    background: none;
                }
                .van-tab {
                    font-size: 14px;
                    color: #222;
                    font-weight: 500;
                }
                .van-tab--active {
                    font-weight: 600;
                    color: #286df7;
                    font-size: 16px !important;
                }
                .van-tabs__line {
                    background-color: rgba(40, 109, 247, 0.9);
                }
            }
        }
        .content_bottom {
            display: flex;
            ::v-deep {
                .van-list__finished-text,
                .van-loading__circular,
                .van-loading__text {
                    color: #323233;
                    font-size: 12px;
                }
            }
        }
        .title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 14px 10px 4px;
            .left {
                color: rgba(55, 58, 77, 0.9);
                font-size: 16px;
                font-weight: 600;
            }
            .right {
                display: flex;
                align-items: center;
                justify-content: space-between;
                p {
                    color: #555;
                    text-align: right;
                    font-size: 12px;
                }
            }
        }
        .van-sidebar {
            width: 80px;
        }
        .nav {
            width: 90px;
            flex-shrink: 0;
            border-right: 1px solid #eaeaeb;
            padding: 0 4px;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
            ::v-deep {
                .van-sidebar-item {
                    background: none;
                    padding: 0;
                    text-align: center;
                    font-size: 12px;
                    margin: 10px 0;
                    height: 25px;
                    line-height: 25px;
                }
                .van-sidebar-item__text {
                    color: #286df7;
                    width: 100%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .van-sidebar-item--select {
                    background: #0070ff;
                    border-radius: 4px;

                    .van-sidebar-item__text {
                        color: #fff !important;
                    }
                }

                .van-sidebar-item--select::before {
                    display: none;
                }
            }
        }
        .bottom_right {
            width: calc(100% - 80px);
            .title {
                .specialBg {
                    position: relative;
                    z-index: 0;
                    &::before {
                        content: '';
                        background: linear-gradient(
                            90deg,
                            rgba(74, 128, 235, 0.673) 0%,
                            rgba(100, 151, 255, 0) 100%
                        );
                        border-radius: 15px;
                        position: absolute;
                        width: 67px;
                        height: 11px;
                        bottom: -2px;
                        left: 0;
                        z-index: -1;
                    }
                }
                .right {
                    .sort_d {
                        position: relative;
                        margin-right: 10px;
                        height: 21px;
                        display: flex;
                        align-items: center;
                        .angle_top {
                            content: '';
                            width: 0;
                            height: 0;
                            display: block;
                            border-style: solid;
                            border-width: 0 4px 4px;
                            border-color: transparent transparent #999;
                            position: absolute;
                            transform: rotate(180deg);
                            bottom: 5px;
                            right: -9px;
                        }

                        .angle_bottom {
                            content: '';
                            width: 0;
                            height: 0;
                            display: block;
                            border-style: solid;
                            border-width: 0 4px 4px;
                            border-color: transparent transparent #999;
                            position: absolute;
                            top: 5px;
                            right: -9px;
                        }

                        .angle_top_checked {
                            border-color: transparent transparent #286df7;
                        }

                        .angle_bottom_checked {
                            border-color: transparent transparent #286df7;
                        }
                    }
                }
            }
            .nav-details {
                overflow-y: auto;
                padding: 0 10px 70px 10px;
                -webkit-overflow-scrolling: touch;
                ::v-deep {
                    .common {
                        background: #fff;
                        border-radius: 8px;
                        padding: 10px 8px;
                        height: 78px;
                        position: relative;
                        border: 1px solid #f5f6f9;
                        margin: 4px 0;
                        border-radius: 8px;
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        .gs {
                            border-radius: 8px;
                            border: 1px solid #2999df;
                            padding: 0 4px;
                            color: #2999df;
                            font-size: 10px;
                            margin-left: 4px;
                            flex-shrink: 0;
                        }
                        .handleClickYz {
                            position: absolute;
                            right: -1px;
                            top: -1px;
                            border-radius: 0px 6.86px 0px 6.86px;
                            overflow: hidden;
                            img {
                                width: 17px;
                                height: 16px;
                                flex-shrink: 0;
                            }
                        }

                        h2 {
                            // display: flex;
                            // align-items: center;
                            // align-self: flex-start;
                            // width: 100%;
                            .FactorName {
                                font-size: 14px;
                                color: rgba(0, 0, 0, 0.9);
                                font-weight: bold;
                                width: 116px;
                                // padding-right: 8px;
                            }
                            .pElementsSpan {
                                margin-right: 4px;
                            }
                            .vipIcon {
                                width: 20px;
                                height: 13px;
                                display: inline-block;
                                margin-bottom: -1.5px;
                            }
                            b {
                                color: #3b85fe;
                            }
                            .XiFenZhongLei {
                                color: rgba(40, 109, 247, 1);
                                font-size: 12px;
                                background: rgba(40, 109, 247, 0.1);
                                padding: 2px 10px;
                                border-radius: 4px;
                                display: inline-block;
                            }
                        }
                        .n-content {
                            border-radius: 4px;
                            padding: 4.5px 6px;
                            background: rgba(0, 0, 0, 0.02);
                            display: flex;
                            align-items: center;
                            align-self: flex-end;
                            width: 100%;
                            p {
                                font-size: 12px;
                                &:first-child {
                                    margin-right: 8px;
                                }
                            }
                        }
                    }
                    .special {
                        height: 45px;
                        display: flex;
                        align-items: center;
                        .special_con {
                            flex-shrink: 0;
                            width: 100%;
                            .FactorName {
                                font-size: 14px;
                                color: rgba(0, 0, 0, 0.9);
                                font-weight: bold;
                                width: 100%;
                                flex-shrink: 0;
                                // .specialFactorName {
                                //   border: 1px solid #f00;
                                // }
                            }
                        }
                    }
                }
            }
        }
    }
    .bottom-pd {
        // position: absolute;
        position: fixed;
        bottom: 34px;
        left: 0px;
        width: 100%;
        padding: 0 16px;
        z-index: 1997;
        .bottom-btn {
            border-radius: 20px;
            background: #0e0c0d;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            z-index: 9;

            .left {
                font-size: 16px;
                color: #fff;
                display: flex;
                align-items: center;
                padding: 8px 0 8px 23px;
                .num {
                    font-size: 14px;
                    width: 24px;
                    height: 24px;
                    border-radius: 8px;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    background: #3b85fe;
                    margin-left: 8px;
                }
            }
            .r-btn {
                font-size: 16px;
                color: #858586;
                padding: 0px 16px;
                background: #1b3b82;
                border-radius: 0 20px 20px 0;
                height: 40px;
                display: flex;
                align-items: center;
            }
        }
    }
}
::v-deep {
    .van-action-sheet__content {
        // padding: 0 16px 120px 16px;
        padding: 0 16px 35px 16px;
    }
    // .actionSheet-content {
    //   border-radius: 8px;
    //   padding: 8px;
    //   background: #f7f7fc;
    //   li {
    //     margin: 6px 0;
    //     border: 1px solid #e7e7e7;
    //     padding: 3.5px;
    //     border-radius: 4px;
    //     display: flex;
    //     align-items: center;
    //     justify-content: space-between;
    //     background: #fff;
    //     .a-left {
    //       font-size: 14px;
    //       color: rgba(0, 0, 0, 0.9);
    //       padding-left: 9.5px;
    //       .gs {
    //         border-radius: 20px;
    //         border: 1.5px solid #2999df;
    //         padding: 0 8px;
    //         color: #2999df;
    //         font-size: 10px;
    //         margin-left: 4px;
    //         flex-shrink: 0;
    //         height: 20px;
    //         line-height: 19px;
    //       }
    //       .XiFenZhongLei {
    //         font-size: 10px;
    //         color: #999;
    //       }
    //     }
    //     .a-right {
    //       border-radius: 4px;
    //       padding: 8px 12px;
    //       background: rgba(0, 0, 0, 0.02);
    //       display: flex;
    //       align-items: center;
    //       justify-content: space-between;
    //       width: 50%;
    //       font-size: 12px;
    //       color: #555;
    //       img {
    //         width: 17px;
    //         height: 16px;
    //         flex-shrink: 0;
    //       }
    //     }
    //   }
    // }
    .null {
        font-size: 14px;
        text-align: center;
        color: #ccc;
        height: 40px;
        line-height: 40px;
    }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
    ::v-deep {
        .van-icon-play {
            color: #e4e9fe !important;
        }
    }
    ::v-deep {
        .van-tab,
        .van-tab__text {
            color: #e4e9fe !important;
        }
        .van-tab--active {
            color: #fff !important;
        }
        .van-tabs__wrap {
            border-bottom: none !important;
        }
        .van-tabs__line {
            background-color: #fff !important;
        }
    }
    .bottom_right {
        .title {
            .left {
                color: #e4e9fe;
            }
            .right {
                .sort_d {
                    color: #e4e9fe;
                }
            }
        }
    }
    .popup_body {
        padding: 16px;
        .title {
            color: #e4e9fe;
            font-size: 16px;
            font-weight: 500;
        }
        .background {
            background: #2b2d3d;
        }
        .btn {
            .cancel {
                background: #1e1f2d;
                color: #286df7;
            }
            .add {
                color: #e4e9fe;
            }
        }
        .zhi,
        .XiFenZhongLei,
        .Desc {
            color: #e4e9fe;
        }
    }
    .content {
        .nav {
            border-right: none;
        }
        .bottom_right {
            .nav-details {
                ::v-deep {
                    .common {
                        background: rgb(28, 32, 44) !important;
                        border: 1px solid rgb(28, 32, 44);
                        .FactorName {
                            color: #e4e9fe !important;
                        }

                        .n-content {
                            background: #2e3548 !important;
                            .desc,
                            .left p,
                            .zhi,
                            p {
                                color: #aab9d1;
                            }
                        }
                    }
                }
            }
        }

        .content_bottom {
            ::v-deep {
                .van-list__finished-text,
                .van-loading__circular,
                .van-loading__text {
                    color: #aab9d1;
                }
            }
        }
    }
    .bottom-btn {
        background: #2e3548 !important;
    }
    ::v-deep {
        .van-popup,
        .actionSheet-title {
            background: rgb(30, 31, 45);
        }
        .actionSheet-title {
            .name {
                color: #aab9d1;
            }
        }
    }
    .actionSheet-content {
        background: #2e3548;
        li {
            background: rgb(30, 31, 45);
            border: 1px solid rgb(30, 31, 45);
            color: #e4e9fe;
            .a-left,
            .a-right .zhi {
                color: #e4e9fe;
            }

            .XiFenZhongLei {
                color: #6b7687;
            }

            .a-right {
                color: #aab9d1;
            }
        }
    }
}
</style>
